import BodyTextMedium from "./BodyTextMedium";
import Box from "./Box";
import Button from "./Button";
import PropTypes from "prop-types";
import React from "react";

function JumpToSection({ sectionName, sectionId }) {
  return (
    <Button
      onClick={() => {
        document
          .getElementById(sectionId)
          .scrollIntoView({ behavior: "smooth" });
      }}
    >
      <Box mr={20} py={10} transition="opacity 200ms" hover="opacity 0.5">
        <BodyTextMedium color="white" uppercase underline>
          {sectionName}
        </BodyTextMedium>
      </Box>
    </Button>
  );
}

export default JumpToSection;

JumpToSection.propTypes = {
  sectionName: PropTypes.string.isRequired,
  sectionId: PropTypes.string.isRequired,
};
